export default __webpack_public_path__ + "static/mtn_momo_small-df626234f81e52ac13476d2ec801886d.jpg";